import React, { use, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { Link, useNavigate } from "react-router-dom";
import storage from "../../Assets/js/Global";
import { imagePath } from "../../Url";
import LogOutModal from "../../modals/LogOutModal";
import {
  Bell,
  // Bell,
  Fingerprint,
  Languages,
  LockKeyhole,
  LogOut,
  MessageCircleQuestionMark,
  Trash,
} from "lucide-react";
import { images } from "../../Assets/images";
import BiometricDrawer from "../../Components/BiometricDrawer";

const Profile = () => {
  const {
    getUserDetails,
    userDetails,
    doLogout,
    handleChangePassword,
    handleDeletAccount,
    translatedLabels,
    getLanguageList,
    languages,
    notificationOnOff,
    setNotificationsEnabled,
    notificationsEnabled,
    is4Life,
  } = useContext(GlobalContext);

  const screenLabels = translatedLabels?.common;

  const capitalize = (str) =>
    typeof str === "string" && str.length > 0
      ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      : "";

  const fullName =
    userDetails?.first_name && userDetails?.last_name
      ? `${capitalize(userDetails.first_name)} ${capitalize(
          userDetails.last_name,
        )}`
      : "";

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  let getToggleStatus = storage.get("biometricAuthEnabled");
  let isActive = getToggleStatus === true ? true : false;
  const [biometricEnabled, setBiometricEnabled] = useState(isActive);
  const [showBiometricDrawer, setShowBiometricDrawer] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const selectedLanguage = storage.get("selectedLanguage");
  const selectedLangObj = languages.find(
    (lang) => lang.language_code === selectedLanguage,
  );
  const displayLanguage = selectedLangObj?.language_translate;

  useEffect(() => {
    getLanguageList();
  }, [getLanguageList]);

  useEffect(() => {
    getUserDetails();
    console.log("====================================");
    console.log(userDetails?.expiry_date);
    console.log("====================================");
  }, [getUserDetails]);

  const handleBiometricToggle = () => {
    const newValue = !biometricEnabled;

    if (!newValue) {
      setBiometricEnabled(false);
      storage.set("biometricAuthEnabled", "false");
      const loginObj = storage.get("loginObj");
      const userId = loginObj?.userKey;
      window.ReactNativeWebView?.postMessage(`disableBioMetrics|${userId}`);
    } else {
      setShowBiometricDrawer(true);
    }
  };

  const handleNotificationToggle = () => {
    const newValue = !notificationsEnabled;
    setNotificationsEnabled(newValue);
    const numericValue = newValue ? 1 : 0;
    notificationOnOff(numericValue);
  };

  return (
    <>
      <div className="content-part px-0">
        <div className="profile-bg">
          <div className="mb-3">
            <div className="text-center">
              <div className="d-flex justify-content-center mb-2">
                <div className="user-profile-image position-relative">
                  <img
                    src={
                      imagePath + userDetails?.profile_photo || images.userImage
                    }
                    alt="user"
                    onClick={() => setImageModalOpen(true)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = images.userImage;
                    }}
                  />
                </div>
              </div>
              <h4 className="text-bold mb-0">{fullName || ""}</h4>
              <p className="text-muted text-md  mb-0">
                {is4Life ? userDetails?.secondary_email : userDetails?.email}
                {/* {userDetails?.email || ""} */}
              </p>
              {/* ADD HERE */}
              {/* <p className="text-muted text-sm m-0 fst-italic fs-12" style={{ fontSize: "clamp(0.75rem, 2vw, 0.875rem)" }}>
                Plan expires on: {userDetails?.expiry_date || "N/A"}
              </p> */}
              <Link className="edit-profile-btn" to="/profile-update">
                {screenLabels?.edit_profile?.label_value || "Edit Profile"}
                <i className="fa-solid fa-angle-right ms-1"></i>
              </Link>
            </div>
          </div>
        </div>

        <p
          className="text-muted text-uppercase text-md px-3 mb-0"
          style={{ marginTop: "38px" }}
        >
          {screenLabels?.preferences?.label_value || "Preferences"}
        </p>

        <div className="mt-1">
          <div className="card-box">
            <ProfileItem
              icon={<Languages size={20} />}
              label={screenLabels?.language?.label_value || "Language"}
              value={displayLanguage}
              link="/language-selection"
            />
            <ProfileItem
              icon={<Bell size={20} />}
              label={
                screenLabels?.notifications?.label_value || "Notifications"
              }
              isToggle={true}
              toggleValue={notificationsEnabled}
              onToggleChange={handleNotificationToggle}
            />
            <ProfileItem
              icon={<Fingerprint size={20} />}
              label={screenLabels?.biometric?.label_value || "Biometric Login"}
              isToggle={true}
              toggleValue={biometricEnabled}
              onToggleChange={handleBiometricToggle}
            />
            <ProfileItem
              icon={<MessageCircleQuestionMark size={20} />}
              label={screenLabels?.faqs?.label_value || "FAQs"}
              link="/help-guide"
            />
            {!is4Life && (
              <ProfileItem
                icon={<LockKeyhole size={20} />}
                label={
                  screenLabels?.change_pass?.label_value || "Change Password"
                }
                onClick={handleChangePassword}
              />
            )}

            {(!is4Life || userDetails?.secondary_email) && (
              <ProfileItem
                icon={<Trash size={20} />}
                label={
                  screenLabels?.delete_account?.label_value || "Delete Account"
                }
                onClick={handleDeletAccount}
              />
            )}
            {/* <ProfileItem
              icon={<Trash size={20} />}
              label={
                screenLabels?.delete_account?.label_value || "Delete Account"
              }
              onClick={handleDeletAccount}
            /> */}
            <ProfileItem
              icon={<LogOut size={20} />}
              label={screenLabels?.log_out?.label_value || "Logout"}
              onClick={() => setShowLogoutModal(true)}
            />
          </div>
        </div>
      </div>

      <LogOutModal
        show={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={() => {
          setShowLogoutModal(false);
          doLogout();
        }}
        screenLabels={screenLabels}
      />

      {showBiometricDrawer && (
        <BiometricDrawer
          openDirectly={true}
          onClose={(confirmed) => {
            setShowBiometricDrawer(false);
            setBiometricEnabled(confirmed);
            storage.set("biometricAuthEnabled", confirmed.toString());
          }}
        />
      )}
      {imageModalOpen && (
        <div
          className="image-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
          }}
          onClick={() => setImageModalOpen(false)}
        >
          <div
            style={{
              position: "relative",
              width: "360px",
              height: "360px",
              borderRadius: "50%",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={
                userDetails?.profile_photo
                  ? imagePath + userDetails.profile_photo
                  : images.userImage
              }
              alt="Full View"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

const ProfileItem = ({
  icon,
  label,
  value,
  link,
  onClick,
  isToggle,
  toggleValue,
  onToggleChange,
}) => {
  const navigate = useNavigate();
  const content = (
    <div className="list-style">
      <div className="d-flex gap-3 align-items-center">
        <div>{icon}</div>
        <span>{label}</span>
      </div>
      <div className="d-flex gap-2 align-items-center">
        {isToggle ? (
          <label className="switch">
            <input
              id="bioMetric"
              type="checkbox"
              checked={toggleValue}
              onChange={onToggleChange}
            />
            <span className="slider round"></span>
          </label>
        ) : (
          <>
            {value && <span className="text-muted">{value}</span>}
            <i className="fa-solid fa-angle-right"></i>
          </>
        )}
      </div>
    </div>
  );

  return link && !isToggle ? (
    <div onClick={() => navigate(link)} className="text-decoration-none">
      {content}
    </div>
  ) : (
    <div
      role="button"
      className="text-decoration-none"
      onClick={!isToggle ? onClick : undefined}
    >
      {content}
    </div>
  );
};

export default Profile;
